import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {



    private modalState = new BehaviorSubject<boolean>(false);
    modalState$ = this.modalState.asObservable();

    openModal() {
        this.modalState.next(true);
    }

    closeModal() {
        this.modalState.next(false);
    }
    // private apiUrl = 'assets/blogs/blogs.json'; // Path to your local JSON file
    //
    // constructor(private http: HttpClient) {}
    //
    // getBlogs(): Observable<any> {
    //     return this.http.get<any>(this.apiUrl);
    // }
}
